import { CashierContact } from '../checkoutTypes';

export function cashierContactToUpdateAddressRequest(contact?: CashierContact) {
  return {
    country: contact?.countryCode ?? null,
    subdivision: contact?.state ?? null,
    postalCode: contact?.postalCode ?? null,
    city: contact?.city ?? null,
    streetAddress: null as any,
    addressLine1: contact?.addressLine1 ?? null,
    addressLine2: contact?.addressLine2 ?? null,
    location: null as any,
  };
}

export function cashierContactToUpdateContactRequest(contact?: CashierContact) {
  return {
    firstName: contact?.firstName ?? null,
    lastName: contact?.lastName ?? null,
    phone: contact?.phone ?? null,
    company: null,
    vatId: null as any,
  };
}
